module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('loading', {
    attrs: {
      "show": _vm.disabled,
      "text": _vm.disabledText
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btn",
    class: {
      disabled: _vm.disabled
    }
  }, [_vm._v(_vm._s(_vm.title))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4acae14a","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plugin/bottombtn.vue
// module id = 311
// module chunks = 1